export default __webpack_public_path__ + "static/media/ECE-graf-PLA-FLEXA3-5.512087db.png";